export const AUTHENTICATION = {
  LOGIN: {
    DO: "AUTHENTICATION_LOGIN_DO",
    POST: "AUTHENTICATION_LOGIN_POST",
    REQUEST: "AUTHENTICATION_LOGIN_REQUEST",
    RECEIVE: "AUTHENTICATION_LOGIN_RECEIVE",
    FAILURE: "AUTHENTICATION_LOGIN_FAILURE"
  },
  LOGIN_FEDERATED_LINK: {
    DO: "AUTHENTICATION_LOGIN_FEDERATED_LINK_DO",
    POST: "AUTHENTICATION_LOGIN_FEDERATED_LINK_POST",
    REQUEST: "AUTHENTICATION_LOGIN_FEDERATED_LINK_REQUEST",
    RECEIVE: "AUTHENTICATION_LOGIN_FEDERATED_LINK_RECEIVE",
    FAILURE: "AUTHENTICATION_LOGIN_FEDERATED_LINK_FAILURE",
    CLEAR_ERROR: "AUTHENTICATION_LOGIN_FEDERATED_LINK_CLEAR_ERROR"
  },
  LOGIN_FEDERATED_EXCHANGE: {
    DO: "AUTHENTICATION_LOGIN_FEDERATED_EXCHANGE_DO",
    POST: "AUTHENTICATION_LOGIN_FEDERATED_EXCHANGE_POST",
    REQUEST: "AUTHENTICATION_LOGIN_FEDERATED_EXCHANGE_REQUEST",
    RECEIVE: "AUTHENTICATION_LOGIN_FEDERATED_EXCHANGE_RECEIVE",
    FAILURE: "AUTHENTICATION_LOGIN_FEDERATED_EXCHANGE_FAILURE"
  },
  LOGOUT: {
    DO: "AUTHENTICATION_LOGOUT_DO",
    POST: "AUTHENTICATION_LOGOUT_POST",
    POST_COMPLETE: "AUTHENTICATION_LOGOUT_POST_COMPLETE",
    REQUEST: "AUTHENTICATION_LOGOUT_REQUEST",
    RECEIVE: "AUTHENTICATION_LOGOUT_RECEIVE",
    FAILURE: "AUTHENTICATION_LOGOUT_FAILURE"
  },
  REFRESH: {
    DO: "AUTHENTICATION_REFRESH_DO",
    POST: "AUTHENTICATION_REFRESH_POST",
    REQUEST: "AUTHENTICATION_REFRESH_REQUEST",
    RECEIVE: "AUTHENTICATION_REFRESH_RECEIVE",
    FAILURE: "AUTHENTICATION_REFRESH_FAILURE"
  },
  AUTHORISED: "AUTHENTICATION_AUTHORISED",
  INACTIVITY_WARNING: {
    DO: "AUTHENTICATION_INACTIVITY_WARNING_DO",
    RESET: "AUTHENTICATION_INACTIVITY_WARNING_RESET_ERROR"
  },
  LAST_ACTIVITY: "AUTHENTICATION_LAST_ACTIVITY",
  STARTUP_SUCCESS: "STARTUP_SUCCESS",
  STARTUP_FAILED: "STARTUP_FAILED",
  RESET: "AUTHENTICATION_RESET"
};
